module.exports = __webpack_public_path__ + "static/media/entrega.9ab8621b.png";